<template>
  <div class="offerItem">
    <div class="offerItem__ContentWrapper">
      <div class="offerItem__ImageWrapper">
        <Flare :srcset="data.image" size="both" width="644" height="430" crop="fill" :alt="data.image" />
        <div v-if="data.image_document_discount?.meta?.format === 'svg' && data.image_document_discount.meta.url" class="offerItem__DiscountWrapper">
          <img :src="data.image_document_discount.meta.url" :alt="data.image_document_discount.title || ''" width="250" height="150" />
        </div>
      </div>
      <div class="offerItem__Content">
        <div class="offerItem__Top">
          <div v-if="data.travel_date_from && data.travel_date_to">{{ formatDate(data.travel_date_from) }} - {{ formatDate(data.travel_date_to) }}</div>
          <p v-if="offerItemAccommodationData?.place?.name" v-text="offerItemAccommodationData.place.name" />
        </div>
        <h3><span>{{ data.title }}</span> <span>{{ data.subtitle }}</span></h3>
        <div v-if="offerItemAccommodationData?.category_rating" class="offerItem__StarsWrapper">
          <img v-for="i in offerItemAccommodationData.category_rating" src="/resources/images/icons/star.svg" width="14" height="14" alt="Star" />
        </div>
      </div>
      <NuxtLink :to="data.sef">{{ data.title }}</NuxtLink>
    </div>
  </div>
</template>

<script setup>
  const props = defineProps({
    data: {},
  });

  const accommodationsData = useState('accommodationsData');

  const offerItemAccommodationData = computed(() => {
    if (props.data.accommodations?.length > 1) return
    return accommodationsData.value[props.data.accommodations[0]]
  });
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_offerItem.scss');
</style>